<template>
    <div>
        <div v-if="!isReady" class="text-xs-center">
            <v-progress-circular indeterminate color="primary" />
        </div>
        <GChart
            type="ComboChart"
            :settings="{ packages: ['corechart'], language: $i18n.locale }"
            :data="data"
            :options="chartOptions"
            :events="chartEvents"
            @ready="onChartReady"
        />
    </div>
</template>

<script>
import { merge } from 'lodash';
import { GChart } from 'vue-google-charts';
import exportService from '@/services/exportService';
import chartActionResetMixin from '@/mixins/chartActionResetMixin';
import chartActionSelectDateMixin from '@/mixins/chartActionSelectDateMixin';
import chartTooltipPositionMixin from '@/mixins/chartTooltipPositionMixin';

export default {
    name: 'combo-chart-graph',
    mixins: [
        chartActionResetMixin,
        chartActionSelectDateMixin,
        chartTooltipPositionMixin,
    ],
    components: {
        GChart,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            baseOptions: {
                seriesType: 'bars',
                series: { 0: { type: 'line', targetAxisIndex: 1 } },
                curveType: 'function',
                colors: [this.$vuetify.theme.secondary, this.$vuetify.theme.primary],
                legend: {
                    position: 'top',
                    maxLines: 3,
                    pagingTextStyle: {
                        color: this.$vuetify.theme.tertiary,
                    },
                    scrollArrows: {
                        activeColor: this.$vuetify.theme.tertiary,
                        inactiveColor: `${this.$vuetify.theme.tertiary}4c`,
                    },
                },
                hAxis: {
                    slantedText: true,
                },
                vAxis: {
                    format: 'short',
                },
                chartArea: {
                    top: 35,
                    left: 50,
                    right: 50,
                    width: '90%',
                    height: '65%',
                },
                backgroundColor: '#f5f5f5',
                selectionMode: 'multiple',
                tooltip: {
                    trigger: 'selection',
                    isHtml: true,
                },
            },
            chartEvents: {
                ready: () => {
                    this.isReady = true;
                    this.addChartActionReset();
                    this.addChartActionSelectDate();
                    this.addChartTooltipPosition();
                },
                select: () => {
                    this.addChartActionSelectDate();
                },
            },
            isReady: false,
            chart: null,
            google: null,
        };
    },
    computed: {
        chartOptions() {
            const baseHeight = this.options.height ? this.options.height : 300;
            const height = this.expanded ? window.outerHeight - 60 : baseHeight;
            return merge(this.baseOptions, this.options, { height });
        },
    },
    methods: {
        onChartReady(chart, google) {
            this.chart = chart;
            this.google = google;
            this.$emit('ready');
        },
        exportData(title = 'export') {
            exportService.exportDataImage(this.chart.getImageURI(), title);
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
